import React from 'react'

import PropTypes from 'prop-types'

import './faq1.css'

const FAQ1 = (props) => {
  return (
    <div className="faq1-faq7 thq-section-padding">
      <div className="faq1-max-width thq-section-max-width">
        <div className="thq-flex-column">
          <h2 className="thq-heading-2">{props.heading1}</h2>
          <p className="faq1-text1 thq-body-large">{props.content1}</p>
        </div>
        <div className="thq-flex-column faq1-list">
          <div className="faq1-list-item1">
            <p className="faq1-faq1-question thq-body-large">
              {props.faq1Question}
            </p>
            <span className="thq-body-small">{props.faq1Answer}</span>
          </div>
          <div className="faq1-list-item2">
            <p className="faq1-faq2-question thq-body-large">
              {props.faq2Question}
            </p>
            <span className="thq-body-small">{props.faq2Answer}</span>
          </div>
          <div className="faq1-list-item3">
            <p className="faq1-faq3-question thq-body-large">
              {props.faq3Question}
            </p>
            <span className="thq-body-small">{props.faq3Answer}</span>
          </div>
          <div className="faq1-list-item4">
            <p className="faq1-faq4-question thq-body-large">
              {props.faq4Question}
            </p>
            <span className="thq-body-small">{props.faq4Answer}</span>
          </div>
          <div className="faq1-list-item5">
            <p className="faq1-faq5-question thq-body-large">
              {props.faq5Question}
            </p>
            <span className="thq-body-small">{props.faq5Answer}</span>
          </div>
        </div>
        <div className="thq-flex-column">
          <div className="faq1-content1">
            <h2 className="thq-heading-2">{props.heading2}</h2>
            <p className="faq1-text3 thq-body-large">{props.content2}</p>
          </div>
          <div className="faq1-container">
            <button className="thq-button-outline faq1-button">
              <span className="thq-body-small">{props.action1}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

FAQ1.defaultProps = {
  faq5Question: 'How can I get started with your digital marketing services?',
  heading2: 'Still have a question?',
  heading1: 'FAQs',
  faq2Question: 'Do you provide customized marketing plans?',
  faq5Answer:
    'To get started with our digital marketing services, simply contact us through our website or give us a call, and we will guide you through the process.',
  faq3Answer:
    'Yes, we offer pricing plans for different services to cater to the specific needs of our clients.',
  faq1Answer:
    'We offer services such as SEO, social media marketing, PPC advertising, and website design to help businesses improve their online presence.',
  action1: 'Contact',
  faq1Question: 'What digital marketing services do you offer?',
  faq3Question: 'Do you have pricing plans for your services?',
  faq4Answer:
    'Yes, we feature testimonials from satisfied clients who have benefited from our services.',
  faq2Answer:
    'Yes, we provide customized marketing plans and strategies tailored to meet specific business goals.',
  content2: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ',
  content1:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.',
  faq4Question: 'Do you have testimonials from clients?',
}

FAQ1.propTypes = {
  faq5Question: PropTypes.string,
  heading2: PropTypes.string,
  heading1: PropTypes.string,
  faq2Question: PropTypes.string,
  faq5Answer: PropTypes.string,
  faq3Answer: PropTypes.string,
  faq1Answer: PropTypes.string,
  action1: PropTypes.string,
  faq1Question: PropTypes.string,
  faq3Question: PropTypes.string,
  faq4Answer: PropTypes.string,
  faq2Answer: PropTypes.string,
  content2: PropTypes.string,
  content1: PropTypes.string,
  faq4Question: PropTypes.string,
}

export default FAQ1
